const RestrictionsFacade = require('../facade/restrictions/restrictions');
const OverOutHandler = require('./helper/overwritable').OverOutHandler;
const getElementOnCoords = require('./helper/overwritable').getElementOnCoords;

module.exports = function (S) {
  const overHandler = new OverOutHandler(S, 'ghost-icon');

  return {
    outIcon: overHandler.out,
    updateIconDimensions: function (opts) {
      overHandler.updateContentDimensions(opts.elem);
    },
    dragIcon: function (opts) {
      const icons = $(S.svgroot).find('.element.icon');
      const iconOnPosition = getElementOnCoords(icons, opts.x, opts.y, S.canvas.getZoom());

      if (iconOnPosition) {
        const isRestricted = !RestrictionsFacade.canChange(iconOnPosition, 'replace') ||
          RestrictionsFacade.getElementRestrictions(iconOnPosition.getAttribute('id'), 'source').length;

        isRestricted && S.canvas.call('advice.show', 'restriction-icon-replace');
        isRestricted || overHandler.over(iconOnPosition, opts.thumb);
      } else if (overHandler.getGhostElement()) overHandler.out();

      return iconOnPosition;
    }
  };
};
